import ApplicationController from "./application_controller"

const COOKIE_NAME = "site_notice_banner_dismissed"
const COOKIE_MAX_AGE_DAYS = 365
const BODY_CLASS = "has-site-notice-banner"

export default class extends ApplicationController {
  connect() {
    if (this.isDismissed()) {
      this.element.remove()
      return
    }

    this.applyOffset()
    this.resizeObserver = new ResizeObserver(() => this.applyOffset())
    this.resizeObserver.observe(this.element)
    window.addEventListener("resize", this.applyOffset)
  }

  disconnect() {
    this.teardown()
  }

  dismiss() {
    this.setDismissedCookie()
    this.teardown()
    this.element.remove()
  }

  applyOffset = () => {
    const height = Math.ceil(this.element.getBoundingClientRect().height)
    document.body.style.setProperty("--site-notice-banner-height", `${height}px`)
    document.body.classList.add(BODY_CLASS)
  }

  teardown() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
    window.removeEventListener("resize", this.applyOffset)
    document.body.classList.remove(BODY_CLASS)
    document.body.style.removeProperty("--site-notice-banner-height")
  }

  isDismissed() {
    return document.cookie.split("; ").some((cookie) => cookie === `${COOKIE_NAME}=1`)
  }

  setDismissedCookie() {
    const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60
    document.cookie = `${COOKIE_NAME}=1; Path=/; Max-Age=${maxAge}; SameSite=Lax`
  }
}
